import { MathJaxDirective } from './testtaker/test/mathjax.directive';
import {ChangePipe} from './replace_function';
import { ExcelService } from './services/excel.service';
import { ConfigService } from 'src/app/services/config.service';
import { ReportService } from './services/report.service';
import { CollegeService } from './services/College_name.service';
import { endtestService } from './services/endtest.service';
import { LoginService } from './services/login.service';
import { jobdescService } from './services/jobdesc.service';
import { abouthibizService } from 'src/app/services/abouthibiz.service';
import { instructionService } from './services/instruction.service';
import { questionService } from './services/question.service';
import { CloneService } from './services/cloneset.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { ttsectionComponent } from './testtaker/ttsection/ttsection.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TtinstructionsComponent } from './testtaker/ttinstructions/ttinstructions.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimerComponent, FormatTimePipes } from './testtaker/timer/timer.component';
import { SectionService } from './services/section.service';
import { LogicaltestComponent } from './testtaker/test/logicaltest.component';
import { FormatTimePipe } from './testtaker/test/logicaltest.component';
import { MatIconModule } from '@angular/material/icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatListModule } from '@angular/material/list';
import { HeaderComponent } from './testtaker/header/header.component';
import { FooterComponent } from './testtaker/footer/footer.component';
import { LoginComponent,TrackCapsDirective } from './testtaker/login/login.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MatDialogModule } from '@angular/material/dialog';
import { FinalComponent } from './testtaker/final/final.component';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ResponsiveModule } from 'ngx-responsive';
// import { MatPaginatorModule } from '@angular/material/paginator';
// import {TabComponent} from './tab-component/tab.component';


import { NbLayoutModule, NbMenuModule, NbDatepickerModule } from '@nebular/theme';
import { NbThemeModule, NbSidebarModule } from '@nebular/theme';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DemoMaterialModule1 } from './super_admin/material-module';
import { CreateAdminComponent } from './createAdminUser/createAdmin.component';
import { CreateTestSchedulerComponent } from './createTestScheduler/createTestScheduler.component';
import { CreateTestTakerComponent } from './createTestTaker/createTestTaker.component';
import { AuthenticationService } from './services/authentication.service';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { AuthGuardService } from './services/auth-guard.service';
import { AdminComponent } from './admin/admin.component';
import { SuperAdminComponent } from './super_admin/super_admin.component';
import { TestSchedulerComponent } from './test_scheduler/test_scheduler.component';
import { TestTakerComponent } from './test_taker/test_taker.component';
import { EditAdminComponent } from './edit/edit.component';
// import { TakeTestComponent} from './TakeTest/take_test.component';
import { DesignTestComponent } from './designTest/designTest.component';
import { ToastrModule } from 'ngx-toastr';
import { AdminService } from './services/admin.service';
import { TestSchedulerService } from './services/test_scheduler.service';
import { TestTakerService } from './services/test_taker.service';
import { QuestionSetComponent } from './questionset/questionset.component';
import { CloneqnsetComponent } from './clone-question-set/clone-question-set.component'
import { QuestionSetService } from './services/questionset.service';
import { EditQuestionSetComponent } from './edit-questionset/edit-questionset.component';
import { GenerateSetComponent } from './generateset/generateset.component';
import { AlertsModule } from 'angular-alert-module';
// import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ScheduleTestComponent } from './scheduletest/scheduletest.component';
import { MaterialModule } from './material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatNativeDateModule } from '@angular/material';
import { ScheduleTestViewComponent } from './scheduledtest_view/scheduledtest_view.component';
import { OverAllResultComponent } from './overall_result/overall_result.component';
import { IndividualResultComponent } from './individual_result/individual_result.component';
import { ChangePasswordComponent } from './change_password/change_password.component';
import { EvaluateMarksComponent } from './evaluate_marks/evaluate_marks.component';
import { MatCheckboxModule, MatCardModule } from '@angular/material';
import { EditTestTakerComponent } from './edit_testtaker/edit_testtaker.component';
import { ForgotPasswordComponent } from './forgot_password/forgot_password.component';
import { ResetPasswordComponent } from './reset_password/reset_password.component';
import { PinCheckComponent } from './pin_check/pin.component';
import { FeedbackComponent } from './testtaker/feedback/feedback.component';
import { UploadCandidateComponent } from './upload candidate/candidate.component';
import { UploadQuestionBankComponent } from './upload-question-bank/upload-question-bank.component';
import { YearService } from './services/year.service';
import { EssayEvaluationComponent } from './essay-evaluation/essay-evaluation.component';
import { EssayEvaluationViewComponent } from './essay-evaluation-view/essay-evaluation-view.component';
// import { EssayCardViewComponent } from './essay-card-view/essay-card-view.component';
// import { NavigationHeaderComponent } from './navigation-header/navigation-header.component';
import { ViewCandidatesComponent } from './view-candidates/view-candidates.component';
// import { DraggableComponent } from './testtaker/draggable/draggable.component';
import { TesttakerReportComponent } from './testtaker-report/testtaker-report.component';
import { MatSelectModule } from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { QuestionpdfexportComponent } from './questionpdfexport/questionpdfexport.component';
import { GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { TerminateUserComponent } from './terminate-user/terminate-user.component';
import { EditModalComponent } from './edit-modal/edit-modal.component';
import { MatToolbarComponent } from './mat-toolbar/mat-toolbar.component';
import { UrltestComponent } from './testtaker/urltest/urltest.component';
import { AudioanswerComponent } from './testtaker/audioanswer/audioanswer.component';
import { VideoanswerComponent } from './testtaker/videoanswer/videoanswer.component';
import { SampleComponent } from './sample/sample.component';
import { Sample1Component } from './sample1/sample1.component';
import { RecordComponent } from './record/record.component';
import { RecordRTCComponent } from './record-rtc/record-rtc.component';
import { AudioEvaluateComponent } from './audio-evaluate/audio-evaluate.component';
import { AudioViewComponent } from './audio-view/audio-view.component';
import { AudioRecordingService } from './audio-recording.service';
import { VideoRecordingService } from './video-recording.service';
import { UserDetailsComponent } from './testtaker/user-details/user-details.component';
import { userDetailsService } from './services/user.details.service';
import { SnapshotComponent } from './testtaker/snapshot/snapshot.component';
import { MediaUpload } from './services/media-upload.service'
import { UploadAudioVideoImagesComponent } from './upload-audio-video-images/upload-audio-video-images.component';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import {EvaluatorWorkBench} from './evaluator-workbench/evaluator-workbench.component'
import { TestEvaluationComponent } from './test-evaluation/test-evaluation.component';
import {ManualEvaluationComponent} from './manual-evaluation/manual-evaluation.component';
import {ManualEvalQuestionsModalComponent} from './manual-eval-questions-modal/manual-eval-questions-modal.component'
import { CompletedCollegeComponent } from './completed-college/completed-college.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SwalService } from './services/swal.service';
//import { MathjaxComponent } from './testtaker/mathjax/mathjax.component';
// import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SelectQuestionModule } from "./testtaker/select-question/select-question.module";
const config = {
  breakPoints: {
      xs: {max: 600},
      sm: {min: 601, max: 959},
      md: {min: 960, max: 1279},
      lg: {min: 1280, max: 1919},
      xl: {min: 1920}
  },
  debounceTime: 100
};

const routes: Routes = [
  { path: 'instruction', component: TtinstructionsComponent },
  { path: 'section', component: ttsectionComponent },
  { path: 'test/:id', component: LogicaltestComponent },
  { path: 'urltest/:id', component: UrltestComponent },
  { path: 'record/:id', component: AudioanswerComponent },
  { path: 'videorecord/:id', component: VideoanswerComponent },
  { path: 'final', component: FinalComponent },
  { path: 'feedback', component: FeedbackComponent },
  // { path: 'tab', component: TabComponent },
  { path: '', component: LoginComponent },

  { path: 'forgot_password', component: ForgotPasswordComponent },
  { path: 'pin_check', component: PinCheckComponent },
  { path: 'reset_password/:token', component: ResetPasswordComponent },

  // { path: 'take_test', component: TakeTestComponent},
  { path: 'createAdmin', component: CreateAdminComponent },
  { path: 'createTestScheduler', component: CreateTestSchedulerComponent },
  { path: 'createTestTaker', component: CreateTestTakerComponent },
  { path: 'edit/:id', component: EditAdminComponent },
  { path: 'admin', component: AdminComponent, data: { title: 'Admin' } },
  { path: 'super_admin', component: SuperAdminComponent, data: { title: 'Super Admin' } },
  { path: 'test_scheduler', component: TestSchedulerComponent, data: { title: 'Test Scheduler' } },
  { path: 'test_taker', component: TestTakerComponent, data: { title: 'Test Taker' } },
  { path: 'designTest', component: DesignTestComponent },
  { path: 'question_set', component: QuestionSetComponent },
  {path:'clonequestion_set',component:CloneqnsetComponent},
  { path: 'edit_question_set/:id', component: EditQuestionSetComponent },
  { path: 'generate_set/:id', component: GenerateSetComponent },
  { path: 'schedule_test', component: ScheduleTestComponent },
  { path: 'scheduled_test_view', component: ScheduleTestViewComponent },
  { path: 'overall_result', component: TesttakerReportComponent },
  //{ path: 'individual_result/:id', component: IndividualResultComponent },
  { path: 'individual_result', component: IndividualResultComponent },
  { path: 'change_password', component: ChangePasswordComponent },
  { path: 'evaluate_marks', component: EvaluateMarksComponent },
  { path: 'edit_testtaker/:id', component: EditTestTakerComponent },
  { path: 'upload_candidate', component: UploadCandidateComponent },
  { path: 'upload_question_bank', component: UploadQuestionBankComponent },
  { path: 'upload_media', component: UploadAudioVideoImagesComponent},
  { path: 'evaluate_essay', component: EssayEvaluationComponent },
  { path: 'evaluate_audio', component: AudioEvaluateComponent },
  { path: 'evaluate_essay_view', component: EssayEvaluationViewComponent },
  { path: 'evaluate_audio_view', component: AudioViewComponent },
  { path: 'evaluator_workbench', component: EvaluatorWorkBench },
  {path:  'questionpdfexport',component:QuestionpdfexportComponent},
  {path:  'terminate-user',component:TerminateUserComponent},
  // { path: 'view_essay', component: EssayCardViewComponent},
  // {path:'header',component:NavigationHeaderComponent},
  { path: 'view_candidates', component: ViewCandidatesComponent },
  { path: 'sample1', component: Sample1Component },
  { path: 'sample', component: SampleComponent },
  { path: 'user_details_form', component: UserDetailsComponent },
  { path: 'take_snapshot', component: SnapshotComponent },
  { path: 'test_evaluation', component: TestEvaluationComponent},
  { path: 'manual_evaluation', component:ManualEvaluationComponent},
  {path:'view_completed_college', component:CompletedCollegeComponent},
  {path:'student_details_workbench', component:StudentDetailsComponent}
];


@NgModule({
  declarations: [
    AppComponent,
    ttsectionComponent,
    TtinstructionsComponent,
    TimerComponent,
    FormatTimePipe,
    FormatTimePipes,
    LogicaltestComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    FinalComponent,
    PinCheckComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    AdminComponent,
    SuperAdminComponent,
    TestSchedulerComponent,
    TestTakerComponent,
    CreateAdminComponent,
    CreateTestSchedulerComponent,
    CreateTestTakerComponent,
    EditAdminComponent,
    // TakeTestComponent,
    DesignTestComponent,
    QuestionSetComponent,
    CloneqnsetComponent,
    EditQuestionSetComponent,
    GenerateSetComponent,
    ScheduleTestComponent,
    ScheduleTestViewComponent,
    OverAllResultComponent,
    IndividualResultComponent,
    ChangePasswordComponent,
    EvaluateMarksComponent,
    EditTestTakerComponent,
    SampleComponent,
    ChangePipe,
    FeedbackComponent,
    UploadCandidateComponent,
    UploadQuestionBankComponent,
    EssayEvaluationComponent,
    EssayEvaluationViewComponent,
    // EssayCardViewComponent,
    // NavigationHeaderComponent,
    ViewCandidatesComponent,
    // DraggableComponent,
    TesttakerReportComponent,
    TrackCapsDirective,
    //MathjaxComponent,
    MathJaxDirective,
    QuestionpdfexportComponent,
    TerminateUserComponent,
    EditModalComponent,
    MatToolbarComponent,
    UrltestComponent,
    RecordRTCComponent,
    AudioanswerComponent,
    VideoanswerComponent,
    AudioEvaluateComponent,
    AudioViewComponent,
    EvaluatorWorkBench,
    Sample1Component,
    UserDetailsComponent,
    SnapshotComponent,
    UploadAudioVideoImagesComponent,
    // TabComponent,
    TestEvaluationComponent,
    ManualEvaluationComponent,
    ManualEvalQuestionsModalComponent,
    CompletedCollegeComponent,
    StudentDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    MatTabsModule,
    HttpClientModule,
    MatIconModule,
    //  MatPaginatorModule,
    MatListModule,
    MatRadioModule,
    // NgbModule.forRoot(),
    ReactiveFormsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    MDBBootstrapModule.forRoot(),
    ResponsiveModule.forRoot(config),
    MatDialogModule,
    MatGridListModule,
    MatStepperModule,
    NbThemeModule.forRoot(),
    NbMenuModule.forRoot(),
    MatSidenavModule,
    NbSidebarModule.forRoot(),
    NbLayoutModule,
    MatSelectModule,
    RouterModule.forRoot(routes, { useHash: true }),
    DemoMaterialModule1,
    ToastrModule.forRoot(),
    AlertsModule.forRoot(),
    // AngularFontAwesomeModule,
    NbDatepickerModule.forRoot(),
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgbModule,
    MatCheckboxModule,
    MatListModule,
    MatCardModule,
    NgxUsefulSwiperModule,
    MatAutocompleteModule,
    GridModule,
    PDFModule,
    SelectQuestionModule
],
  providers: [AudioRecordingService,CloneService, VideoRecordingService,questionService, SectionService, instructionService, jobdescService, abouthibizService, LoginService,SwalService,
    AuthenticationService, AuthGuardService, AdminService, TestSchedulerService, TestTakerService, QuestionSetService, endtestService, CollegeService, YearService, ReportService, ConfigService, ExcelService, userDetailsService, MediaUpload, {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true}],
  bootstrap: [AppComponent],
  entryComponents: [ttsectionComponent, CreateAdminComponent, ScheduleTestComponent, TesttakerReportComponent, EditModalComponent]

})
export class AppModule { }
